<script lang="ts">
  import FeatherIcon from "svelte-feather-icon";
  import { Col} from "sveltestrap";
  import earning from "../../../Data/ComponentData/WidgetData/Genral/EarningData.json";
  import Card from "../../Core/Card.svelte";
</script>

{#each earning.Earning as earningItem}
  <Col sm="6" xl="3" lg="6">
    <Card cardProps="o-hidden border-0" cardBodyprops="bg-{earningItem.color}">
      <div slot="contentbody">
        <div class="media static-top-widget">
          <div class="align-self-center text-center">
            <FeatherIcon icon={earningItem.icon} />
          </div>
          <div class="media-body">
            <span class="m-0">{earningItem.title}</span>
            <h4 class="mb-0 counter">{earningItem.count}</h4>
            <span class="icon-bg-span">
              <FeatherIcon class="icon-bg" icon={earningItem.icon} />
            </span>
          </div>
        </div>
      </div>
    </Card>
  </Col>
{/each}
